import { z } from 'zod';

export const RefreshTokenSchema = z.object({
  refreshToken: z.string().min(1, 'Refresh token cannot be empty'),
});

export type IRefreshTokenDto = z.infer<typeof RefreshTokenSchema>;
